export default {"src":"/_next/static/media/company-name.59c0238f.svg","height":16,"width":168};